import React from "react";
import { slide as Menu } from "react-burger-menu";
import "./sidebar.css";
import BurgerIcon from "../../../assets/sprites/navigation/burger.png";

export default function Sidebar(props: any) {
  return (
    <Menu customBurgerIcon={<img src={BurgerIcon} />} {...props}>
      {props.children}
    </Menu>
  );
}
